<script setup lang="ts">
import { useSidebar } from './sidebar-provider.vue'

const { isRail, toggleRail } = useSidebar()
</script>

<template>
  <div class="absolute -right-1.5 top-1/2 cursor-pointer" @click="toggleRail()">
    <div class="bg-muted flex h-6 w-3 items-center justify-center rounded-sm border">
      <gat-icon
        :icon="$icons.common.ChevronLeft"
        class="size-4"
        :class="{ 'rotate-180': isRail }"
      />
    </div>
  </div>
</template>
